<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="modal detail_box"
    >

      <div class="detail">
        <div class="titles msp_icon_close">
          <span class="title_name">图片详情</span>
          <span
            class="iconfont el-icon-close"
            @click.stop="closeBox()"
          />
        </div>

        <div class="detail_el_scroll">
          <div class="detail_img">
            <!-- eslint-disable -->
            <div class="detail_img_info">
              <el-image
                :src="matterinfodata.url"
                :alt="alt"
                :fit="fit"
                style="width:100%; height: 200px"
                class="el-image-class"
              >
                <div
                  slot="error"
                  class="image-slot"
                >
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>

            </div>

            <div class="editor_logs">
              <div class="editor_logs_content">
                <div
                  class="upload_each_info_detail upload_input_info_detail"
                  style="padding-left:10px;"
                >
                  <span class="star">*</span>
                  <span>素材名称：</span>
                  <el-input
                    v-model="matterinfodata.title"
                    placeholder="请输入素材名称"
                    maxlength="60"
                  ></el-input>
                </div>
                <div
                  class="upload_each_info_detail"
                  style="padding-left:18px;"
                >
                  <span>上&nbsp;&nbsp;传&nbsp;&nbsp;者：</span>
                  <span class="need_textdot">{{ username }}</span>
                </div>

                <div class="upload_each_info_detail upload_input_tags_detail">
                  <span>素材标签：</span>
                  <el-cascader
                    v-model="matterinfodata.tagIds"
                    :options="tagsTree"
                    :props='cascaderProps'
                    :size='cascaderSize'
                    :show-all-levels="false"
                    ref='cascaderref'
                    filterable
                    @change="handleChange"
                  ></el-cascader>
                </div>

                <div class="upload_each_info_detail">
                  <span>关&nbsp;&nbsp;键&nbsp;&nbsp;词：</span>
                  <div class="key_words">
                    <el-tag
                      :key="tag"
                      v-for="tag in matterinfodata.keywords"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(tag)"
                    >
                      {{tag}}
                    </el-tag>
                    <el-input
                      class="input-new-tag"
                      v-if="inputVisible"
                      v-model="inputValue"
                      ref="saveTagInput"
                      size="small"
                      maxlength="10"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showInput"
                    >+ 添加关键词</el-button>
                  </div>
                </div>

                <div class="upload_each_info_detail upload_input_info_detail">
                  <span>素材描述：</span>
                  <el-input
                    type="textarea"
                    placeholder="请填写内容"
                    v-model="matterinfodata.detail"
                    maxlength="100"
                    :show-word-limit='true'
                  ></el-input>
                </div>

              </div>
            </div>
          </div>
          <div class="detail_img_sort">
            <div
              class="sort_button"
              style="left:20px;"
              @click.stop="lastPage()"
            >
              <span class="iconfont el-icon-arrow-left"></span>
            </div>
            <div
              class="sort_button"
              style="right:20px;"
              @click.stop="nextPage()"
            >
              <span class="iconfont el-icon-arrow-right"></span>
            </div>
            <div class="detail_img_sortlist">
              <div
                class="detail_each_sortimg"
                v-for="(item,index) in currentPageList"
                :key="index"
                @click.stop="showCurrentMatter(item)"
              >
                <el-image
                  :src="item.url"
                  :alt="alt"
                  :fit="fit"
                  style="width:100%; height: 188px"
                  class="el-image-class"
                >
                  <div
                    slot="error"
                    class="image-slot"
                  >
                    <i class="el-icon-picture-outline" />
                  </div>
                </el-image>
                <div class="opacity_title">
                  <span>{{item.title}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="pic_button">
            <el-button
              type="primary"
              @click.native="sureSubmit()"
            >确定</el-button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {

  },
  data () {
    return {
      visible: false,
      fit: 'contain',
      alt: '图片加载失败',

      matterinfodata: {},
      pageDatalist: [],
      currentPageList: [],
      currentPageIndex: 1,
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        expandTrigger: 'hover'
      },
      cascaderSize: 'medium',
      inputVisible: false,
      inputValue: '',
      orgmMtterinfodata: '',
      orgpPageDatalist: []
    }
  },
  computed: {
    tagsTree () {
      return this.$store.state.tags.matterTagsTree
    },
    username () {
      return this.$store.state.userinfo.username
    }
  },
  mounted () {
    this.$root.eventHub.$on('changeUploadPicModel', (data, datalist) => {
      this.visible = true
      this.matterinfodata = data
      this.pageDatalist = datalist
      if (datalist.length > 0) {
        for (var i = 0; i < datalist.length; i++) {
          if (datalist[i].url === data.url) {
            if (i > 0) {
              this.currentPageIndex = Math.floor((i / 6) + 1)
            } else {
              this.currentPageIndex = 1
            }
            break;
          }
        }
      }
      this.pagination(this.currentPageIndex, 6, this.pageDatalist)
      this.orgmMtterinfodata = JSON.parse(JSON.stringify(data))
      this.orgpPageDatalist = JSON.parse(JSON.stringify(datalist))
    })
  },
  destroyed () {
    this.$root.eventHub.$off('changeUploadPicModel')
  },
  methods: {
    closeBox () {
      this.visible = false
      this.$root.eventHub.$emit('setOrgpicModel', this.orgmMtterinfodata, this.orgpPageDatalist)
    },
    sureSubmit () {
      this.visible = false
    },
    pagination (pageNo, pageSize, array) {
      var offset = (pageNo - 1) * pageSize
      this.currentPageList = (offset + pageSize >= array.length) ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize)
    },
    lastPage () {
      this.currentPageIndex = this.currentPageIndex - 1
      if (this.currentPageIndex > 0) {
        this.pagination(this.currentPageIndex, 6, this.pageDatalist)
      } else {
        this.$notify.warning({
          title: '警告',
          message: '没有更多数据了'
        })
        this.currentPageIndex = 1
      }
    },
    nextPage () {
      this.currentPageIndex = this.currentPageIndex + 1
      var allIndex = Math.ceil(this.pageDatalist.length / 6)
      if (this.currentPageIndex > allIndex) {
        this.$notify.warning({
          title: '警告',
          message: '没有更多数据了'
        })
        this.currentPageIndex = allIndex
      } else {
        this.pagination(this.currentPageIndex, 6, this.pageDatalist)
      }
    },
    showCurrentMatter (item) {
      this.matterinfodata = item
    },
    handleChange (val) {
      var node = this.$refs.cascaderref.getCheckedNodes()
      var tags = []
      for (var i = 0; i < node.length; i++) {
        for (var j = 0; j < this.matterinfodata.tagIds.length; j++) {
          if (node[i].value === this.matterinfodata.tagIds[j]) {
            tags.push(node[i].label)
          }
        }
      }
      this.matterinfodata.tags = tags
    },
    handleClose (tag) {
      this.matterinfodata.keywords.splice(this.matterinfodata.keywords.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.matterinfodata.keywords.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.detail_box
  .detail
    position relative
    width 80%
    height 88%
    border-radius 6px
    background #E9EAEC
    box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.35)

    .titles
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      background #fff
      box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)

      .title_name
        float left
        color #303133
        font-size 16px
        line-height 48px

      .iconfont
        float right
        color #606266
        font-size 22px
        line-height 48px
        cursor pointer

    .detail_el_scroll
      overflow auto
      box-sizing border-box
      height calc(100% - 48px)

      .detail_img
        display flex
        box-sizing border-box
        margin-top 20px
        padding-right 20px
        padding-left 60px
        height 60%

        .operate_img
          box-sizing border-box
          padding-top 20px

        .detail_img_info
          position relative
          display flex
          flex 1
          justify-content center
          align-items center
          box-sizing border-box
          margin-left 2px
          padding 20px
          height 100%
          border-radius 6px
          background #fff

        .editor_logs
          margin-left 64px
          width 440px
          height 100%
          border-radius 6px
          background #fff

        .editor_logs_content
          overflow auto
          box-sizing border-box
          padding-top 20px
          height 100%

          .upload_each_info_detail
            display flex
            box-sizing border-box
            margin-bottom 20px
            padding-left 18px

            span
              color #606266
              font-size 14px

            .need_textdot
              display inline-block
              overflow hidden
              width 76%
              text-overflow ellipsis
              white-space nowrap

            .key_words
              box-sizing border-box
              padding 10px 10px 10px 10px
              min-height 80px
              width 330px
              border 1px solid #DBE0EC
              border-radius 4px
              background #F7F8FA

          .upload_input_info_detail, .upload_input_tags_detail
            span
              line-height 36px

            .star
              margin-right 4px
              color #F56969

      .detail_img_sort
        position relative
        display flex
        box-sizing border-box
        margin-top 20px
        margin-bottom 20px
        padding-right 62px
        padding-left 72px
        height 188px

        .sort_button
          position absolute
          top 0px
          width 42px
          height 100%
          border 1px solid #F0F1F3
          border-radius 6px
          background #fff
          text-align center
          line-height 188px
          cursor pointer
          transition all 0.3s ease-in-out

          &:hover
            background #688EFF

            span
              color #fff

          span
            color #606266
            font-size 26px

        .detail_img_sortlist
          display flex
          flex 1
          box-sizing border-box
          margin-right 10px
          margin-left 10px
          height 188px

          .detail_each_sortimg
            position relative
            flex 1
            box-sizing border-box
            margin-right 10px
            max-width 250px
            height 100%
            background #fff
            cursor pointer
            transition all 0.3s ease-in-out

            &:hover
              box-shadow 0px 1px 10px 2px rgba(131, 128, 128, 0.2)
              transform scale(1.03)

            .opacity_title
              position absolute
              bottom 0
              left 0
              z-index 10
              box-sizing border-box
              padding-left 10px
              width 100%
              height 38px
              background rgba(0, 0, 0, 0.7)

              span
                display inline-block
                overflow hidden
                width 98%
                color #fff
                text-overflow ellipsis
                white-space nowrap
                font-size 16px
                line-height 38px

      .pic_button
        display flex
        justify-content flex-end
        align-items center
        box-sizing border-box
        padding-right 20px
        height 60px
</style>
